import DocumentEditor from 'components/Editor/DocumentEditor';

const NotFound = () => (
  <DocumentEditor>
  </DocumentEditor>
)

export default NotFound
